import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#00A1A1",
    "col1n": "#007070",
    "col2d": "#4D2E1B",
    "col2l": "#AC8268",
    "col2n": "#794D32"
}
function PlaFor042({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill="#FFF"
                    d="M90.95-13.5h209v371.95h265.3v-555.6H350.8q-.044.221-.05.45v-.45H-180.2v555.6H90.95V-13.5z"
                    id="PlaFor042__Layer10_0_FILL"
                />
                <path
                    fill={colors.col1n}
                    d="M745.45 190.35V0H0v190.35h745.45M531 144.85h-.05v-.05l.05.05z"
                    id="PlaFor042__Symbol_90_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    fillOpacity={0.302}
                    d="M745.45 545.75V0H531q-.044.175-.05.4V0H0v545.75h271.15v-362.1h209v362.1h265.3z"
                    id="PlaFor042__Symbol_91_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M745.45 397.5v-16.75H626.3V1.9L619.9 0 486.95 29.35v-14.6H258.5v366H0v16.75h258.5v3.3h18.65l8.5-17.35V44.95h174.1v338.5l8.45 17.35 151.7 33.4 6.4-3.35V397.5h119.15z"
                    id="PlaFor042__Symbol_92_0_Layer0_0_FILL"
                />
                <g
                    id="PlaFor042__Symbol_93_0_Layer0_0_FILL"
                    fill={colors.col2l}
                >
                    <path d="M0 354.25v3.35h258.5v-3.35H0m586.95-75.9l2.65-3.1-98-8.7v77.9l2.2-2.7.05-.1-.2-.05v-71.8l93.3 8.55m-301.3-259.9l-8.5-11.55v367.4l8.5-17.35V18.45M468.2 6.9l-8.45 11.55v338.5l8.45 17.35V6.9m15.5 347.85l-2.1 2.7 49.35 9.8h.05l71.05 14.1V258.4l-2.65 3.3v115.45L531 363.9h-.05l-47.25-9.15m103.25-332.3l2.65-3.95-98 17.8v178.25l2.2-3.2.05-.1h-.2V38.95l93.3-16.5M602.05 0l-2.65 3.95v226.7l-115.7-4.75-2.1 3.05 120.45 5.45V0m143.4 357.6v-3.35H626.3v3.35h119.15z" />
                    <path
                        fillOpacity={0.4}
                        d="M459.75 18.45L468.2 6.9H277.15l8.5 11.55h174.1z"
                    />
                </g>
                <g
                    id="PlaFor042__Symbol_94_0_Layer0_0_FILL"
                    fill={colors.col2d}
                >
                    <path
                        fillOpacity={0.502}
                        d="M209.7 33.4l18.75-4.05v-14.6H0V400.8h18.65V33.4H209.7z"
                    />
                    <path d="M331.1 301.75l-2.65 3.1v79.85l-93.15-16.45-2.2 2.7 98 17.7v-86.9m9.8-13.55l2.65-3.3-120.45-8.45v107.5l2.1-2.7.05-.2h-.1v-101.4l115.75 8.55M367.8 1.9L361.4 0v434.2l6.4-3.35V1.9M331.1 45l-2.65 3.95v191.2l-93.15-2.3-2.2 3.2 98 2.7V45m9.8-14.55l2.65-3.95L223.1 50.3v205.15l2.1-3.05.05-.1h-.1V52.9L340.9 30.45z" />
                </g>
                <g id="PlaFor042__Layer1_0_FILL">
                    <path
                        fill="#CCC"
                        d="M435.45 152.9l-10.55.4v55.15l10.55.25v-55.8z"
                    />
                    <path
                        fill="#7B7B7B"
                        d="M445.1 153.35l-4.45-.55v55.85l4.45-.25v-55.05z"
                    />
                </g>
                <g id="PlaFor042__Layer1_0_MEMBER_0_FILL">
                    <path
                        fill="#7B7B7B"
                        d="M428.8 184.8v10.7h1.9v-10.7h-1.9z"
                    />
                    <path
                        fill="#B1B1B1"
                        d="M403.15 171.45q-.326 1.124.05 2.15 1.236 2.85 5.8 1.95l18.45-.25q3.988.1 5.1-2.7.31-.943 0-1.8-1.104-2.02-3.7-2.2l-20.7.25q-3.904-.292-5 2.6z"
                    />
                </g>
            </defs>
            <use xlinkHref="#PlaFor042__Layer10_0_FILL" />
            <use
                xlinkHref="#PlaFor042__Symbol_90_0_Layer0_0_FILL"
                transform="translate(-180.2 348.6)"
                id="PlaFor042__col1n"
            />
            <use
                xlinkHref="#PlaFor042__Symbol_91_0_Layer0_0_FILL"
                transform="translate(-180.2 -197.15)"
                id="PlaFor042__col1l"
            />
            <use
                xlinkHref="#PlaFor042__Symbol_92_0_Layer0_0_FILL"
                transform="translate(-180.2 -34.85)"
                id="PlaFor042__col2n"
            />
            <use
                xlinkHref="#PlaFor042__Symbol_93_0_Layer0_0_FILL"
                transform="translate(-180.2 -8.35)"
                id="PlaFor042__col2l"
            />
            <use
                xlinkHref="#PlaFor042__Symbol_94_0_Layer0_0_FILL"
                transform="translate(78.3 -34.85)"
                id="PlaFor042__col2d"
            />
            <use xlinkHref="#PlaFor042__Layer1_0_FILL" />
            <use xlinkHref="#PlaFor042__Layer1_0_MEMBER_0_FILL" />
        </g></g>
    )
}
export default PlaFor042
